// For full API documentation, including code examples, visit http://wix.to/94BuAAs
// Website designed by Amber Simpson (Ambersimpsonuk@gmail.com)

$w.onReady(function () {
	//TODO: write your page related code here...

});